import React from 'react';
import type PeopleSettingsType from '@atlassian/jira-spa-apps-project-settings-people/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { type RouteContext, type Match, Redirect } from '@atlassian/react-resource-router';

export const LazyPeopleSettings = lazyForPaint<typeof PeopleSettingsType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-settings-people", jiraSpaEntry: "async-project-settings-people" */ '@atlassian/jira-spa-apps-project-settings-people'
		),
	),
);

const PeopleAccessRedirectInner = ({ match, basePath }: { basePath: string; match: Match }) => (
	<Redirect
		to={`${basePath}/projects/${String(match.params.projectKey)}/settings/access`}
		push={false}
	/>
);

export const peopleAccessRedirect =
	(basePath: string) =>
	({ match }: RouteContext) => <PeopleAccessRedirectInner match={match} basePath={basePath} />;

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage Page={LazyPeopleSettings} pageId="project-settings-people" shouldShowSpinner={false} />
);
